export default [
  {
    label: "Einfamilienhaus",
    value: "001",
  },
  {
    label: "Zwei-/Mehrfamilienhaus",
    value: "002",
  },
];
